import bocapioCakeService from "@/services/cakephp"
import nodeService from "@/services/nodejs"

const getAllAgents = async (state, params) => {
  try {
    var agent = undefined
    if(params == undefined){
      const place = state.rootGetters["auth/getPlace"]
      const user = state.rootGetters["auth/user"]

      agent = user.uuid || place.janooUserUuid
    }
    else{
      agent = params
    }

    await bocapioCakeService.getAgents(agent)
        .then(response => {
          state.commit('SET_AGENTS_LIST', response.list)
        })
  }
  catch (error) {
  }
}

const getAgentByUUID = async (state, uuid) => {
  try {
    const agent = await bocapioCakeService.getAgentByUUID(uuid)
    return agent
  }
  catch (error) {
  }
}

const checkExpressBooking = async (state, payload) => {
  await nodeService.postCheckinExpressBooking(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

// Escrita: o erro sobe para a tela avisar o operador (antes era engolido)
const addBookingAgent = async (state, payload) => {
  await nodeService.postAddBookingAgent(payload)
}

const removeBookingAgent = async (state, payload) => {
  await nodeService.postRemoveBookingAgent(payload)
}

const cancelExpressBooking = async (state, payload) => {
  await nodeService.postCancelExpressBooking(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

// Escrita: o erro sobe para a tela avisar o operador (antes era engolido)
const updateExpressBookingDate = async (state, payload) => {
  await nodeService.postUpdateExpressBookingDate(payload)
}

const updateExpressBookingTickets = async (state, payload) => {
  var form = {
    hash: payload.hash,
    message: payload.message,
    pixRefund: payload.pixRefund,
    pix_code: payload.pix,
    indexes: {}
  }

  form.tickets = payload.tickets.filter(t => t.quantity > 0)
  form.tickets.map(function(value, index){ form.indexes[value.id] = value.quantity })

  delete form.tickets

  if(payload.pixRefund){ form.pix = payload.pix }

  // Escrita: o erro sobe para a tela, que avisa e não trata como sucesso
  await nodeService.postUpdateExpressBookingTickets(form)
}

// /**
//  * Carrega lista de POIs (atrativos) do {{ USER_UUID }}
//  * @param {*} state
//  * @param {*} USER_UUID
//  */
// const fetchProductsList = async (state, USER_UUID) => {
//   state.commit('RESET_PRODUCT_LIST')

//   await nodeService.getPoisByVendor(USER_UUID)
//     .then(response => {
//       state.commit('SET_PRODUCT_LIST', response.data)
//     })
// }

export default {
  getAllAgents,
  getAgentByUUID,
  addBookingAgent,
  removeBookingAgent,
  checkExpressBooking,
  cancelExpressBooking,
  updateExpressBookingDate,
  updateExpressBookingTickets,
  // fetchProductsList,
}
